import 'Styles/common.less';

import 'Components/card/card.less';
import 'Components/info-number/info-number.less';
import 'Components/quote/quote.less';
import 'Components/partners-list/partners-list.less';
import 'Components/section-header/section-header.less';
import 'WebComponents/tabs/tabs.less';

import './apply/apply.less';
import './feedback/feedback.less';
import './news/news.less';
import './promo/promo.less';

//import 'babel-polyfill';
import 'WebComponents/greedy-nav';
import './slider';
//import 'WebComponents/adaptive-background';
import { A11y } from 'WebComponents/a11y';
import Promise from 'babel-runtime/core-js/promise'; 
//const mapContext = require('bundle-loader?lazy&name=russia-map!!svg-inline-loader!Images/russia-map.svg');

const a11y = new A11y();
a11y.init();

if (!window.Promise) {
  window.Promise = Promise;
}

const componentContext = [
  require("bundle-loader?lazy&name=tabs!WebComponents/tabs")
];

const symbolsContext = [
  require('bundle-loader?lazy&name=home-symbols!./symbols'),
]
document.addEventListener("DOMContentLoaded", () => {
  !PROD && document.body.classList.add('is-debug');
  componentContext.forEach((context) => {
    context(() => {});
  });
});

// TODO: replace onload to scroll to container event
window.addEventListener("load", () => {
  symbolsContext.forEach((context) => {
    context(() => {});
  });
  /*mapContext((file) => {});*/
});



// WEBPACK FOOTER //
// ./src/pages/home/index.js